export default __webpack_public_path__ + "static/media/rajnish.349b6db2.png";